import React from "react";
import { Box, Typography } from "@mui/material";

import { capitalizeFirstLetterFullString as capitalizeLetter } from "@utils/index";
import { maskCNPJAlfa } from "@utils/fiscal/cnpj/cnpj.helpers";

import { SelectField, SelectFieldProps } from "./SelectField";
import { SelectOption } from "./interface";

/**
 * SelectField pré-configurado para exibição de CNPJ.
 * Wrapper fino sobre SelectField — usado em múltiplos módulos.
 */

export const SelectCNPJ: React.FC<SelectFieldProps> = (props) => {
  const formatLabel = (value: unknown, options: SelectOption[]) => {
    const option = options.find((o) => o.value === value);
    const companyName = (option?.label ?? "").split("|")[0].trim();

    return `${capitalizeLetter(companyName)} | ${
      maskCNPJAlfa(String(option?.value ?? "")) ?? ""
    }`;
  };

  const renderMenuItem = (option: SelectOption) => {
    const companyName = option.label.split("|")[0].trim();

    return (
      <Box>
        <Typography variant="body1" sx={{ fontWeight: 400 }}>
          {capitalizeLetter(companyName)}
        </Typography>
        <Typography variant="body2" sx={{ color: "grey.500" }}>
          {maskCNPJAlfa(String(option.value ?? ""))}
        </Typography>
      </Box>
    );
  };

  return (
    <SelectField
      {...props}
      formatLabel={formatLabel}
      renderMenuItem={renderMenuItem}
    />
  );
};
